import { create } from "zustand";

/** 会员等级详情沿用旧 Vue memberRecord 的持久化键和字段结构。 */
export const MEMBER_LEVEL_STORE_KEY = "zhihao-member";

export interface MemberLevelRecord {
    id: number;
    name?: string;
    state?: number | string;
    yearFee?: number;
    yearDiscountFee?: number;
    yearDiscountFlag?: number;
    giftFlag?: number;
    giftDuration?: number;
    giftDurationUnit?: number;
    memberPermission?: Record<string, unknown>;
    feature?: Record<string, unknown>;
}

export interface ReactMemberLevelStore {
    memberRecord: Partial<MemberLevelRecord>;
    setMemberRecord: (record: MemberLevelRecord | Partial<MemberLevelRecord>) => void;
}

/** 从旧 Vue Pinia 兼容的持久化 state 中恢复最近选中的等级记录。 */
function loadMemberRecord(): Partial<MemberLevelRecord> {
    if (typeof localStorage === "undefined") return {};

    try {
        const persisted = JSON.parse(localStorage.getItem(MEMBER_LEVEL_STORE_KEY) || "{}") as {
            memberRecord?: Partial<MemberLevelRecord>;
            state?: { memberRecord?: Partial<MemberLevelRecord> };
        };
        const record = persisted.memberRecord || persisted.state?.memberRecord;
        return record && typeof record === "object" ? record : {};
    } catch {
        return {};
    }
}

/** 保存与旧 Vue `persist: true` 相同形状的 memberRecord 状态。 */
function persistMemberRecord(record: Partial<MemberLevelRecord>) {
    if (typeof localStorage !== "undefined") {
        localStorage.setItem(MEMBER_LEVEL_STORE_KEY, JSON.stringify({ memberRecord: record }));
    }
}

const initialMemberRecord = loadMemberRecord();

/** 保存列表当前选择项，使不带 id 的详情路由与旧 Vue 一致。 */
export const useMemberLevelStore = create<ReactMemberLevelStore>(set => ({
    memberRecord: initialMemberRecord,
    setMemberRecord: record => {
        set({ memberRecord: record });
        persistMemberRecord(record);
    }
}));
